import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-4 pb-4"
}
const _hoisted_2 = { class: "row g-3 align-items-stretch p-2 p-md-0" }
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = { class: "p-2 p-md-0" }
const _hoisted_6 = { class: "p-2 p-md-0" }

import { computed } from 'vue'

  // Store
  import { useStore } from '@/store'
  import useScreenSize from '@/composables/useScreenSize'

  // Components
  import Booking from '@/components/common/Booking.vue'
  import ReservationSummary from '@/components/common/ReservationSummary.vue'
  import DocumentsSection from '@/components/ConfirmedReservations/BookingPanel/DocumentsSection/DocumentsSection.vue'
  import PaymentSection from '@/components/ConfirmedReservations/BookingPanel/PaymentSection/PaymentSection.vue'
  import TravellersSection from '@/components/ConfirmedReservations/BookingPanel/TravellersSection/TravellersSection.vue'
  import NeedHelpSection from '@/components/ConfirmedReservations/BookingPanel/NeedHelpSection/NeedHelpSection.vue'
  // import StickyBar from '@/components/ConfirmedReservations/BookingPanel/StickyBar.vue'

  // Get the selected booking from the Vuex store
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BookingPanel',
  setup(__props) {

  const store = useStore()
  const { isMobile } = useScreenSize()
  const selectedBooking = computed(
    () => store.getters['booking/selectedBooking']
  )

return (_ctx: any,_cache: any) => {
  return (selectedBooking.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Booking, {
          booking: selectedBooking.value,
          isPanelView: true
        }, null, 8, ["booking"]),
        _createVNode(ReservationSummary, {
          booking: selectedBooking.value,
          "hide-action-button": _unref(isMobile)
        }, null, 8, ["booking", "hide-action-button"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TravellersSection, { booking: selectedBooking.value }, null, 8, ["booking"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(PaymentSection, { booking: selectedBooking.value }, null, 8, ["booking"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(DocumentsSection, { booking: selectedBooking.value }, null, 8, ["booking"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(NeedHelpSection)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})